import { IoCopyOutline } from "react-icons/io5";
import { MdAutoGraph } from "react-icons/md";
import { GoTrophy } from "react-icons/go";
import { FaNetworkWired } from "react-icons/fa";
import React, { useEffect, useState } from "react";
import Image from "next/image";
import { cn } from "@/lib/utils";
import { useDarkTheme } from "@/contexts/DarkTheme";
const index = ({ filtersAuthors, setFiltersAuthors }: any) => {
  let [sortOptions, setSortOptions] = useState([]);
  const { darkTheme } = useDarkTheme();
  const handleChange = (key: string, value: string) => {
    setFiltersAuthors((prev: any) => ({
      ...prev,
      [key]: value,
    }));
  };
  const [isDark, setIsDark] = useState(false);
  useEffect(() => {
    setIsDark(darkTheme);
  }, [darkTheme]);
  return (
    <div
      className={cn(
        `w-full  flex items-center rounded-sm p-1`,
        isDark ? "bg-[--marketplace-brown]" : "bg-[hsl(var(--muted))]"
      )}
    >
      <div
        className={`text-sm w-[38px] h-[23px] flex justify-center  cursor-pointer rounded hover:bg-[hsl(var(--background))] ${
          filtersAuthors.sort_order == "win_p_desc" &&
          "bg-[hsl(var(--background))]"
        }`}
        onClick={() => {
          handleChange("sort_order", "win_p_desc");
        }}
      >
        <Image
          width={12}
          height={12}
          src="/images/marketplace/crown1.png"
          alt="copiers image"
          className={`object-contain ${
            filtersAuthors.sort_order == "win_p_desc"
              ? "marketplace-filter-icon"
              : isDark
              ? ""
              : "marketplace-filter-icon-dark"
          }`}
        />
      </div>

      <div
        className={`text-sm w-[38px] h-[23px] flex justify-center  ml-1  cursor-pointer rounded hover:bg-[hsl(var(--background))] ${
          filtersAuthors.sort_order == "copiers_desc" &&
          "bg-[hsl(var(--background))]"
        }`}
        onClick={() => {
          handleChange("sort_order", "copiers_desc");
        }}
      >
        <Image
          width={10}
          height={10}
          src="/images/marketplace/copiers.png"
          alt="copiers image"
          className={`object-contain ${
            filtersAuthors.sort_order == "copiers_desc"
              ? "marketplace-filter-icon"
              : isDark
              ? ""
              : "marketplace-filter-icon-dark"
          }`}
        />
      </div>
      <div
        className={`text-sm w-[38px] h-[23px] flex justify-center  ml-1   cursor-pointer rounded hover:bg-[hsl(var(--background))] ${
          filtersAuthors.sort_order == "total_trades_desc" &&
          "bg-[hsl(var(--background))]"
        }`}
        onClick={() => {
          handleChange("sort_order", "total_trades_desc");
        }}
      >
        <Image
          width={8}
          height={8}
          src="/images/marketplace/highest.png"
          alt="copiers image"
          className={`object-contain ${
            filtersAuthors.sort_order == "total_trades_desc"
              ? "marketplace-filter-icon"
              : isDark
              ? ""
              : "marketplace-filter-icon-dark"
          }`}
        />
      </div>
      <div
        className={`text-sm w-[38px] h-[23px] flex justify-center  ml-1  cursor-pointer rounded hover:bg-[hsl(var(--background))] ${
          filtersAuthors.sort_order == "total_strategies_desc" &&
          "bg-[hsl(var(--background))]"
        }`}
        onClick={() => {
          handleChange("sort_order", "total_strategies_desc");
        }}
      >
        <Image
          width={8}
          height={8}
          src="/images/marketplace/total1.png"
          alt="copiers image"
          className={`object-contain ${
            filtersAuthors.sort_order == "total_strategies_desc"
              ? "marketplace-filter-icon"
              : isDark
              ? ""
              : "marketplace-filter-icon-dark"
          }`}
        />
      </div>
    </div>
  );
};
export default index;
